import { render, staticRenderFns } from "./InjectionMachine.vue?vue&type=template&id=cacf7664&"
import script from "./InjectionMachine.vue?vue&type=script&lang=js&"
export * from "./InjectionMachine.vue?vue&type=script&lang=js&"
import style0 from "./InjectionMachine.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports